import { getAppConfig } from '@/utils/window.utils';

export const isServiceDisabledForTimeWindowSelection = (serviceId: string | undefined): boolean => {
    if (!serviceId) {
        return false;
    }

    const config = getAppConfig();
    const disabledServiceIds = config.feature.services?.timeWindowSelection?.disabledServiceIds ?? [];

    return disabledServiceIds.includes(serviceId);
};
